/*
 * Verwaltungstexte zu den Ansprechpartner-Paaren (Migration 069, Hausregel „Texte in Properties“): Schlüssel englisch,
 * Werte deutsch. Der Bereichskatalog und das Telefon am Benutzer.
 */
export const CATEGORY_TEXT = {
  area: "Ansprechpartner-Bereiche",
  hint: "Bereiche der Ansprechpartner-Paare an Angebot und Auftrag (Projektleitung, IT-Sicherheit, …). Archivierte sind "
    + "nicht mehr wählbar, eingetragene Paare bleiben; löschen lässt sich nur ein unbenutzter Bereich.",
  loadFailed: "Die Bereiche konnten nicht geladen werden.",
  new: "Neuer Bereich",
  titleNew: "Neuer Bereich",
  titleEdit: "Bereich ändern",
  change: (name: string): string => `${name} ändern`,
  remove: (name: string): string => `${name} löschen`,
  removeShort: "Löschen",
  save: "Speichern",
  changeShort: "Ändern",
  loading: "Lädt …",
  name: "Name",
  sortIndex: "Reihenfolge",
  company: "Gilt für",
  global: "alle Unternehmen",
  archived: "Archiviert (nicht mehr wählbar)",
  archivedChip: "archiviert",
  usage: (n: number): string => (n === 1 ? "an 1 Vorgang" : `an ${String(n)} Vorgängen`),
  order: (n: number): string => `Reihenfolge ${String(n)}`,
  numberMissing: "Bitte eine Zahl eintragen.",
  stale: "Dieser Bereich wurde inzwischen geändert. Deine Eingaben stehen noch da — „Neu laden“ übernimmt den aktuellen Stand.",
  gone: "Dieser Bereich wurde inzwischen gelöscht.",
  confirmSaveTitle: "Bereich speichern?",
  confirmSaveText: (name: string): string => `„${name}“ wird gespeichert und steht an Angebot und Auftrag zur Wahl.`,
  confirmRemoveTitle: "Bereich löschen?",
  confirmRemoveText: (name: string): string => `„${name}“ endgültig löschen? Er ist an keinem Vorgang eingetragen.`,
} as const;

export const USER_TEXT = {
  phone: "Telefon",
  noPhone: "keines",
} as const;
